import axios from 'axios'

const API_BASE_URL = 'https://empresa-service.intrare.app'

// Action types
export const FETCH_AVAILABLE_COMPANIES = 'FETCH_AVAILABLE_COMPANIES'
export const LINK_COMPANY = 'LINK_COMPANY'
export const DELETE_LINK = 'DELETE_LINK'
export const FETCH_CONTRACT = 'FETCH_CONTRACT'
export const INVITE_SECURITY_ADMIN = 'INVITE_SECURITY_ADMIN'
export const FETCH_MY_COMPANY = 'FETCH_MY_COMPANY'
export const FETCH_ADMIN_DASHBOARD = 'FETCH_ADMIN_DASHBOARD'
export const FETCH_GUARDS = 'FETCH_GUARDS'
export const CREATE_GUARD = 'CREATE_GUARD'
export const FETCH_GUARD_DETAIL = 'FETCH_GUARD_DETAIL'
export const UPDATE_GUARD = 'UPDATE_GUARD'
export const ASSIGN_GUARD = 'ASSIGN_GUARD'
export const DELETE_GUARD = 'DELETE_GUARD'
export const FETCH_ACTIVE_SHIFTS = 'FETCH_ACTIVE_SHIFTS'
export const START_SHIFT = 'START_SHIFT'
export const END_SHIFT = 'END_SHIFT'
export const FETCH_ACTIVE_SHIFT = 'FETCH_ACTIVE_SHIFT'
export const DEACTIVATE_ACTIVE_SHIFT = 'DEACTIVATE_ACTIVE_SHIFT'
export const FETCH_MY_CASETAS = 'FETCH_MY_CASETAS'
export const FETCH_PENDING_CONTRACTS = 'FETCH_PENDING_CONTRACTS'
export const RESPOND_TO_CONTRACT = 'RESPOND_TO_CONTRACT'
export const LINK_PARK = 'LINK_PARK'
export const FETCH_MY_PARKS = 'FETCH_MY_PARKS'
export const UNLINK_PARK = 'UNLINK_PARK'
export const RESPOND_TO_PARK_CONTRACT = 'RESPOND_TO_PARK_CONTRACT'
export const ASSIGN_GUARD_TO_PARK = 'ASSIGN_GUARD_TO_PARK'
export const SET_AVAILABLE_COMPANIES = 'SET_AVAILABLE_COMPANIES'
export const SET_CONTRACT = 'SET_CONTRACT'
export const SET_LOADING = 'SET_LOADING'
export const SET_ERROR = 'SET_ERROR'
export const CLEAR_ERROR = 'CLEAR_ERROR'
export const SET_MY_COMPANY = 'SET_MY_COMPANY'
export const SET_ADMIN_DASHBOARD = 'SET_ADMIN_DASHBOARD'
export const SET_GUARDS = 'SET_GUARDS'
export const SET_GUARD_DETAIL = 'SET_GUARD_DETAIL'
export const SET_ACTIVE_SHIFTS = 'SET_ACTIVE_SHIFTS'
export const SET_ACTIVE_SHIFT = 'SET_ACTIVE_SHIFT'
export const SET_MY_CASETAS = 'SET_MY_CASETAS'
export const SET_PENDING_CONTRACTS = 'SET_PENDING_CONTRACTS'
export const SET_MY_PARKS = 'SET_MY_PARKS'
export const SET_PARK_DETAIL = 'SET_PARK_DETAIL'

// Store module
const state = {
  contract: null,
  availableCompanies: [],
  loading: false,
  error: null,
  status: '',
  myCompany: null,
  adminDashboard: null,
  guards: [],
  guardDetail: null,
  activeShifts: [],
  activeShift: null,
  myCasetas: null,
  pendingContracts: [],
  myParks: [],
  parkDetail: null
}

const getters = {
  getContract: state => {
    if (!state.contract) return null;
    if (state.contract.contract) {
      return {
        ...state.contract.contract,
        pending_invitation: state.contract.pending_invitation
      };
    }
    return state.contract;
  },
  getAvailableCompanies: state => {
    if (!state.availableCompanies) return [];
    if (state.availableCompanies.available_security_companies) {
      return state.availableCompanies.available_security_companies;
    }
    return Array.isArray(state.availableCompanies) ? state.availableCompanies : [];
  },
  isSecurityLoading: state => state.loading,
  getSecurityError: state => state.error,
  hasActiveContract: state => {
    if (!state.contract) return false;
    const contractData = state.contract.contract || state.contract;
    return contractData.is_active === true;
  },
  hasAnyContract: state => {
    // Returns true if there's any contract that is not REJECTED or INACTIVE
    // Blocks new invitations/links while contract is PENDING or ACTIVE
    if (!state.contract) return false;
    const contractData = state.contract.contract || state.contract;
    if (!contractData || !contractData.status) return false;
    const status = contractData.status;
    return status !== 'REJECTED' && status !== 'INACTIVE' && status !== null;
  },
  hasPendingInvitation: state => {
    return !!(state.contract && state.contract.pending_invitation);
  },
  getPendingInvitation: state => {
    return (state.contract && state.contract.pending_invitation) || null;
  },
  getSecurityStatus: state => state.status,
  getMyCompany: state => state.myCompany,
  getAdminDashboard: state => state.adminDashboard,
  getGuards: state => state.guards,
  getGuardDetail: state => state.guardDetail,
  getActiveShifts: state => state.activeShifts,
  getActiveShift: state => state.activeShift,
  getMyCasetas: state => state.myCasetas,
  getPendingContracts: state => state.pendingContracts,
  getMyParks: state => state.myParks,
  getParkDetail: state => state.parkDetail
}

const actions = {
  [FETCH_AVAILABLE_COMPANIES]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/available-companies/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_AVAILABLE_COMPANIES, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching available companies')
          reject(err)
        })
    })
  },

  [LINK_COMPANY]: ({ commit }, { token, securityCompanyId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'post',
        url: `${API_BASE_URL}/security/link-company/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: {
          security_company_id: securityCompanyId
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_CONTRACT, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching available companies')
          reject(err)
        })
    })
  },

  [DELETE_LINK]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'delete',
        url: `${API_BASE_URL}/security/link-company/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_CONTRACT, null)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
                    commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error unlinking security company')
          reject(err)
        })
    })
  },

  [FETCH_CONTRACT]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/my-contract/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_CONTRACT, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_CONTRACT, null)
          commit(SET_LOADING, false)
          // No error for 404 - it just means no active contract
          resolve(null)
        })
    })
  },

  [INVITE_SECURITY_ADMIN]: ({ commit }, { token, email, firstName, lastName }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'post',
        url: `${API_BASE_URL}/security/invite-security-admin/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: {
          email,
          first_name: firstName,
          last_name: lastName
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error inviting security admin')
          reject(err)
        })
    })
  },

  [FETCH_MY_COMPANY]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/my-company/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_MY_COMPANY, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching company info')
          reject(err)
        })
    })
  },

  [FETCH_ADMIN_DASHBOARD]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/dashboard/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_ADMIN_DASHBOARD, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching dashboard')
          reject(err)
        })
    })
  },

  [FETCH_GUARDS]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/guards/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_GUARDS, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching guards')
          reject(err)
        })
    })
  },

  [CREATE_GUARD]: ({ commit }, {
    token,
    firstName,
    lastName,
    password,
    avatar,
    ine,
    ineReverso,
    responsibilityFormat,
    sua
  }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      
      const formData = new FormData()
      formData.append('first_name', firstName)
      formData.append('last_name', lastName)
      formData.append('password', password)
      formData.append('ine', ine)
      formData.append('ine_reverso', ineReverso)
      formData.append('responsibility_format', responsibilityFormat)
      if (avatar) formData.append('avatar', avatar)
      if (sua) formData.append('sua', sua)

      const config = {
        method: 'post',
        url: `${API_BASE_URL}/security/guards/`,
        headers: {
          'authorization': `Token ${token}`
        },
        data: formData
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error creating guard')
          reject(err)
        })
    })
  },

  [FETCH_GUARD_DETAIL]: ({ commit }, { token, guardId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/guards/${guardId}/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_GUARD_DETAIL, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching guard details')
          reject(err)
        })
    })
  },

  [UPDATE_GUARD]: ({ commit }, { token, guardId, firstName, lastName, password, avatar, isActive, assignedCompanyId, ine, sua, responsibilityFormat }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      
      const formData = new FormData()
      if (firstName !== undefined) formData.append('first_name', firstName)
      if (lastName !== undefined) formData.append('last_name', lastName)
      if (password) formData.append('password', password)
      if (avatar !== undefined && avatar !== null) formData.append('avatar', avatar)
      if (isActive !== undefined) formData.append('is_active', isActive ? 'true' : 'false')
      if (assignedCompanyId !== undefined) formData.append('assigned_company', assignedCompanyId)
      if (ine !== undefined && ine !== null) formData.append('ine', ine)
      if (sua !== undefined && sua !== null) formData.append('sua', sua)
      if (responsibilityFormat !== undefined && responsibilityFormat !== null) formData.append('responsibility_format', responsibilityFormat)

      const config = {
        method: 'patch',
        url: `${API_BASE_URL}/security/guards/${guardId}/`,
        headers: {
          'Content-Type': 'multipart/form-data',
          'authorization': `Token ${token}`
        },
        data: formData
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error updating guard')
          reject(err)
        })
    })
  },

  [ASSIGN_GUARD]: ({ commit }, { token, guardId, assignedCompanyId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)

      const normalizedAssignedCompanyId = assignedCompanyId === undefined ? null : assignedCompanyId

      const requestConfig = payload => ({
        method: 'patch',
        url: `${API_BASE_URL}/security/guards/${guardId}/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: payload
      })

      // Prefer assigned_company_id (current contract docs); fallback to assigned_company for legacy serializers.
      axios(requestConfig({ assigned_company_id: normalizedAssignedCompanyId }))
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          const hasResponseError = err && err.response && err.response.status >= 400 && err.response.status < 500
          if (!hasResponseError) {
            commit(SET_LOADING, false)
            commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error assigning guard')
            reject(err)
            return
          }

          axios(requestConfig({ assigned_company: normalizedAssignedCompanyId }))
            .then(resp => {
              commit(SET_LOADING, false)
              resolve(resp.data)
            })
            .catch(err2 => {
              commit(SET_LOADING, false)
              commit(SET_ERROR, (err2.response && err2.response.data && err2.response.data.detail) || 'Error assigning guard')
              reject(err2)
            })
        })
    })
  },

  [DELETE_GUARD]: ({ commit }, { token, guardId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'delete',
        url: `${API_BASE_URL}/security/guards/${guardId}/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error deleting guard')
          reject(err)
        })
    })
  },

  [FETCH_ACTIVE_SHIFTS]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/shifts/all-active/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          const shiftsData = Array.isArray(resp.data) ? resp.data : (resp.data.results || [])
          const normalizedShifts = shiftsData.map(shift => ({
            ...shift,
            company_name: shift.company_name || shift.assigned_company_name || 'N/A',
            location: shift.location || shift.caseta_name || '-',
            end_time: shift.end_time || null,
            is_active: shift.is_active === undefined ? true : shift.is_active
          }))

          commit(SET_ACTIVE_SHIFTS, normalizedShifts)
          commit(SET_LOADING, false)
          resolve(normalizedShifts)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching shifts')
          reject(err)
        })
    })
  },

  [START_SHIFT]: ({ commit }, { token, casetaId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const data = {}
      if (casetaId) data.caseta_id = casetaId

      const config = {
        method: 'post',
        url: `${API_BASE_URL}/security/shifts/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: data
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error starting shift')
          reject(err)
        })
    })
  },

  [END_SHIFT]: ({ commit }, { token, shiftId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      
      const config = {
        method: 'patch',
        url: `${API_BASE_URL}/security/shifts/${shiftId}/end/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error ending shift')
          reject(err)
        })
    })
  },

  [FETCH_MY_CASETAS]: ({ commit, rootGetters }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      
      // Determinar el endpoint según el roll del usuario
      const userProfile = rootGetters.getProfile
      let endpoint = `${API_BASE_URL}/empresas/casetas/` // Default para legacy (roll 2)
      
      // Si es guardia Z (roll 9), usar el endpoint de security
      if (userProfile && userProfile.roll === 9) {
        endpoint = `${API_BASE_URL}/security/my-casetas/`
      }
      
      const config = {
        method: 'get',
        url: endpoint,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_MY_CASETAS, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching casetas')
          reject(err)
        })
    })
  },

  [FETCH_PENDING_CONTRACTS]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/pending-contracts/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          // Extraer pending_requests del objeto respuesta
          const pendingRequests = resp.data.pending_requests || []
          commit(SET_PENDING_CONTRACTS, pendingRequests)
          commit(SET_LOADING, false)
          resolve(pendingRequests)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching pending contracts')
          reject(err)
        })
    })
  },

  [RESPOND_TO_CONTRACT]: ({ commit }, { token, contractId, action }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'post',
        url: `${API_BASE_URL}/security/contract/${contractId}/respond/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: {
          action: action
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error responding to contract')
          reject(err)
        })
    })
  },

  [FETCH_ACTIVE_SHIFT]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/shifts/active/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          const activeShift = resp.data.active_shift
          commit(SET_ACTIVE_SHIFT, activeShift)
          commit(SET_LOADING, false)
          resolve(activeShift)
        })
        .catch(err => {
          commit(SET_ACTIVE_SHIFT, null)
          commit(SET_LOADING, false)
          // No error para 404 - solo significa que no hay turno activo
          resolve(null)
        })
    })
  },

  [DEACTIVATE_ACTIVE_SHIFT]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'post',
        url: `${API_BASE_URL}/security/shifts/active/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_ACTIVE_SHIFT, null)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error deactivating shift')
          reject(err)
        })
    })
  },

  [LINK_PARK]: ({ commit }, { token, parkId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'post',
        url: `${API_BASE_URL}/security/link-park/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: {
          park_id: parkId
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error linking park')
          reject(err)
        })
    })
  },

  [FETCH_MY_PARKS]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/my-parks/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          const parks = resp.data.results || resp.data
          commit(SET_MY_PARKS, parks)
          commit(SET_LOADING, false)
          resolve(parks)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching parks')
          reject(err)
        })
    })
  },

  [UNLINK_PARK]: ({ commit }, { token, parkId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'delete',
        url: `${API_BASE_URL}/security/link-park/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        params: {
          park_id: parkId
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error unlinking park')
          reject(err)
        })
    })
  },

  [RESPOND_TO_PARK_CONTRACT]: ({ commit }, { token, contractId, action }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'patch',
        url: `${API_BASE_URL}/security/contract-park/${contractId}/respond/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: {
          action: action
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error responding to park contract')
          reject(err)
        })
    })
  },

  [ASSIGN_GUARD_TO_PARK]: ({ commit }, { token, guardId, parkId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'patch',
        url: `${API_BASE_URL}/security/guards/${guardId}/assign-park/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: {
          assigned_park_id: parkId
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error assigning guard to park')
          reject(err)
        })
    })
  }
}

const mutations = {
  [SET_AVAILABLE_COMPANIES]: (state, companies) => {
    state.availableCompanies = companies
  },
  [SET_CONTRACT]: (state, contract) => {
    state.contract = contract
  },
  [SET_LOADING]: (state, loading) => {
    state.loading = loading
  },
  [SET_ERROR]: (state, error) => {
    state.error = error
    state.status = 'error'
  },
  [CLEAR_ERROR]: (state) => {
    state.error = null
    state.status = ''
  },
  [SET_MY_COMPANY]: (state, company) => {
    state.myCompany = company
  },
  [SET_ADMIN_DASHBOARD]: (state, dashboard) => {
    state.adminDashboard = dashboard
  },
  [SET_GUARDS]: (state, guards) => {
    state.guards = Array.isArray(guards) ? guards : (guards.guards || [])
  },
  [SET_GUARD_DETAIL]: (state, guard) => {
    state.guardDetail = guard
  },
  [SET_ACTIVE_SHIFTS]: (state, shifts) => {
    state.activeShifts = Array.isArray(shifts) ? shifts : (shifts.results || [])
  },
  [SET_ACTIVE_SHIFT]: (state, shift) => {
    state.activeShift = shift
  },
  [SET_MY_CASETAS]: (state, casetas) => {
    state.myCasetas = casetas
  },
  [SET_PENDING_CONTRACTS]: (state, contracts) => {
    state.pendingContracts = Array.isArray(contracts) ? contracts : (contracts.results || [])
  },
  [SET_MY_PARKS]: (state, parks) => {
    state.myParks = Array.isArray(parks) ? parks : (parks.results || [])
  },
  [SET_PARK_DETAIL]: (state, park) => {
    state.parkDetail = park
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
